import { render, staticRenderFns } from "./BaseBgMusic.vue?vue&type=template&id=621096e9&scoped=true&"
import script from "./BaseBgMusic.vue?vue&type=script&lang=js&"
export * from "./BaseBgMusic.vue?vue&type=script&lang=js&"
import style0 from "./BaseBgMusic.vue?vue&type=style&index=0&id=621096e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621096e9",
  null
  
)

export default component.exports